<template>
  <div class="form-container">
    <!-- 电脑端使用 Element UI 表单 -->
    <section v-if="isDesktop" style="padding:0 5%;">
      <el-form
        ref="form"
        label-position="top"
        status-icon
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width:100%;"
      >
        <el-form-item label="角色标识" prop="role_id" required>
          <el-input v-model="form.role_id" placeholder="请输入角色标识,不可重复"></el-input>
        </el-form-item>

        <el-form-item label="角色名称" prop="role_name" required>
          <el-input v-model="form.role_name" placeholder="请输入角色名称"></el-input>
        </el-form-item>

        <el-form-item label="角色权限" prop="permission">
          <el-select v-model="form.permission" multiple placeholder="请选择">
            <el-option
              v-for="(value,key) in permission"
              :key="value.id"
              :label="value.permission_name"
              :value="value.permission_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="icon" >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            v-model="form.comment">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')" :plain="true">立即添加</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 手机端使用 Vant 表单 -->
    <div v-else class="mobile-form-container">
      <div class="mobile-form-content">
        <van-form ref="mobileForm" :model="form" :rules="rules" @submit="onMobileSubmit">
          <!-- 角色标识 -->
          <van-cell-group inset>
            <van-field
              v-model="form.role_id"
              name="role_id"
              input-align="right"
              label="角色标识"
              placeholder="请输入角色标识,不可重复"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 角色名称 -->
            <van-field
              v-model="form.role_name"
              name="role_name"
              input-align="right"
              label="角色名称"
              placeholder="请输入角色名称"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 角色权限 -->
            <van-cell title="角色权限" is-link @click="showPermissionPicker = true">
              <template #right-icon>
                <span>{{ selectedPermissionsText }}</span>
              </template>
            </van-cell>
            
            <!-- 备注 -->
            <van-field
              v-model="form.comment"
              name="comment"
              label="备注"
              input-align="right"
              placeholder="请输入备注"
              type="textarea"
              rows="2"
              autosize
            />
          </van-cell-group>
          
          <!-- 权限选择器 -->
          <van-popup v-model="showPermissionPicker" position="bottom" :round="true" :style="{ height: '50%' }" get-container="body">
            <van-picker
              show-toolbar
              :columns="permissionColumns"
              @confirm="onPermissionConfirm"
              @cancel="showPermissionPicker = false"
              multiple
            />
          </van-popup>
        </van-form>
      </div>
      
      <!-- 手机端固定底部按钮 -->
      <div class="mobile-form-actions">
        <van-button type="default" block @click="close">取消</van-button>
        <van-button type="primary" block @click="onMobileSubmit">立即添加</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  let _this;
  import {addRole,getPermissions} from "@/api/system.js";
  import { Field, Cell, CellGroup, Popup, Picker, Form, Button, Toast } from 'vant';
  let form = {
          role_id: "",
          role_name: "",
          comment: '',
          permission:[]
        }
  export default {
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Form.name]: Form,
      [Button.name]: Button
    },
    data() {
      return {
        isDesktop: true,
        form: form,

        rules: {
          role_id: [
            {required: true, message: "请输入角色标识,不可重复", trigger: "blur"},
          ],
          role_name: [
            {required: true, message: "请输入角色名称", trigger: "blur"},
          ]
        },

        permission:[],
        permission_selected:[],
        
        // 手机端选择器
        showPermissionPicker: false,
        
        // 选择器列数据
        permissionColumns: [],
      };
    },

    computed: {
      // 权限选择文本
      selectedPermissionsText() {
        if (!this.form.permission || this.form.permission.length === 0) {
          return '请选择权限';
        }
        const selectedPermissions = this.permission.filter(perm => this.form.permission.includes(perm.permission_id));
        return selectedPermissions.map(perm => perm.permission_name).join(', ');
      }
    },

    mounted() {
      _this = this;
      _this.init();
      this.checkScreenSize();
      window.addEventListener('resize', this.handleResize);
    },
    
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      // 检查屏幕大小
      checkScreenSize() {
        this.isDesktop = window.innerWidth > 768;
      },
      
      // 处理窗口大小变化
      handleResize() {
        this.checkScreenSize();
      },
      
      // 初始化数据
      init() {
        getPermissions().then(res=>{
          if(res.code === 200){
            this.permission = res.data;
            // 初始化权限选择器列
            this.permissionColumns = this.permission.map(perm => perm.permission_name);
          }
        })
      },
     
      close() {
        _this.$emit("close");
      },
      
      // 电脑端提交
      submit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            addRole(_this.form).then(res => { 
              if (res.code === 200) {
                _this.$message({
                  message: "添加成功",
                  type: "success"
                });
                this.form = form;
                setTimeout(() => {
                  _this.$emit("success");
                }, 1000);
              }
            })
          } else {
            return false;
          }
        })
      },
      
      // 手机端提交
      onMobileSubmit() {
        this.$refs.mobileForm.validate().then(() => {
          // 验证通过，提交数据
          addRole(this.form).then(res => {
            if (res.code === 200) {
              Toast({
                message: '添加成功',
                type: 'success',
                duration: 1500
              });
              setTimeout(() => {
                this.$emit("success");
                this.$emit("close");
              }, 1500);
            } else {
              Toast({
                message: res.message || '添加失败',
                type: 'fail',
                duration: 1500
              });
            }
          }).catch(error => {
            Toast({
              message: '网络错误，请稍后重试',
              type: 'fail',
              duration: 1500
            });
          });
        }).catch(errorInfo => {
          // 验证失败
          console.log('表单验证失败：', errorInfo);
        });
      },
      
      // 权限选择确认
      onPermissionConfirm(values, indexes) {
        this.form.permission = indexes.map(index => this.permission[index].permission_id);
        this.showPermissionPicker = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .form-container {
    width: 100%;
    height: 100%;
  }

  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  .icon-dialog{
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .icon-dialog-list{
      box-sizing: border-box;
      padding: 20px 10px;
      width: 16.66%;
      font-size: 32px;
      text-align: center;
      border:1px solid #dbdbdb;
    }
    .icon-dialog-list:hover{
      color:#409eff;
      border-color:#409eff;
    }
  }
  .icon-name{
    margin-top:10px;
    font-size: 12px;
  }
  
  // 手机端样式
  .mobile-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .mobile-form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
  }

  .mobile-form-actions {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-form-actions .van-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
  }
</style>
<style>
  .el-dialog__body{
    max-height: 60vh;
    overflow-y: auto;
  }
</style>
